import { Button, Dialog } from "@unlimint/admin-ui-kit"

import { useTranslate } from "infrastructure/hooks/useTranslate"

import { useTitle } from "domain/application/hooks/useTitle"
import { CustomizationProvider } from "domain/customization/CustomizationContext"
import { FetchStylesContainer } from "domain/customization/containers/FetchStylesContainer"
import { useOpenable } from "domain/hooks/useOpenable"
import { CreateThemeContainer } from "domain/customization/containers/CreateThemeContainer"

import * as S from "./styled"
import { ThemesGrid } from "./components/ThemesGrid"
import { IntegrationInfo } from "../IntegrationInfo"

export const CustomizationListPage = () => {
  useTitle(useTranslate("pages.сustomization.title"))

  const createdOpenable = useOpenable()

  return (
    <CustomizationProvider>
      <FetchStylesContainer />

      <S.Wrapp>
        <S.Info>
          <IntegrationInfo />
        </S.Info>

        <S.Header>
          <Button
            size="small"
            onClick={createdOpenable.onOpen}
            style={{ textTransform: "none" }}
          >
            Create customization
          </Button>
        </S.Header>

        <ThemesGrid />
      </S.Wrapp>

      <Dialog
        open={createdOpenable.open}
        onClose={createdOpenable.onClose}
        themeOverride={S.Dialog}
      >
        <CreateThemeContainer onClose={createdOpenable.onClose} />
      </Dialog>
    </CustomizationProvider>
  )
}
